import React from "react";
import { Chip, Group } from '@mantine/core';

import { utils } from "../../utils/globalVariables";

const GenderMaleFemaleUngenderedSelectorSingle = ({
    stateValue = '',
    fnOnChange,
}) => {
    return (
        <Chip.Group
            value={stateValue}
            onChange={fnOnChange}
        >
            <Group spacing='xs'>
                {Object.keys(utils.gender).map((key, index) => {
                    return (
                        <Chip
                            key={key}
                            value={String(utils.gender[key].value)}
                            radius='sm'
                        >
                            {utils.gender[key].caption}
                        </Chip>
                    )
                })}
            </Group>
        </Chip.Group>
    )
}

export default GenderMaleFemaleUngenderedSelectorSingle;